import React from "react";
import { Grid, Collapse, Box, useTheme } from "@mui/material";

import DetailsStationTable from "components/tables/stations/DetailsStationTable.component";
import WifiTable from "components/tables/stations/WifiTable.componet";
import CameraTable from "components/tables/stations/CameraTable.componet";
import AmbientTable from "components/tables/stations/AmbientTable.component";
import SensorsList from "containers/management/sensors/SensorsList.container";
import GatwayTable from "components/tables/stations/GatwayTable.component";
import SubCard from "components/common/card/SubCard";
import PeopleCounterTable from "components/tables/stations/PeopleCounterTable.component";

const CollapseStationDetailComponent = ({
  open,
  item,
  setUpdate = () => { },
  handleDeletesensor = () => { },
  isSuperUser,
  openModal,
  handleClose = () => { },
  handleOpen = () => { },
  setIsChageStatusSensor = () => { },
  isChageStatusSensor,
  handleDeletePCount = () => { }
}) => {
  const theme = useTheme()

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      {open && (
        <Box m={1}>
          <Grid container spacing={2} display="flex" alignItems={"center"}>
            <Grid item xs={12} >
              <DetailsStationTable item={item} />
            </Grid>


            <Grid item container xs={12} >
              <SubCard
                sx={{
                  bgcolor: theme.palette.mode === "dark" ? "dark.800" : "grey.50",
                  mb: 2,
                  width: '100%',
                  margingLeft: 16,
                  display: 'flex',
                  justifyContent: 'space-between'

                }}
                content={false}
              >
                <Grid container>
                  <Grid item xs={12} mt={3.9} sm={6} md={6} lg={6}>
                    <AmbientTable item={item} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <SensorsList
                      item={item}
                      setUpdate={setUpdate}
                      handleDeletesensor={handleDeletesensor}
                      openModal={openModal}
                      handleClose={handleClose}
                      handleOpen={handleOpen}
                      setIsChageStatusSensor={setIsChageStatusSensor}
                      isChageStatusSensor={isChageStatusSensor}
                    />
                  </Grid>
                </Grid>
              </SubCard>

            </Grid>

            <Grid item xs={12} >
              <PeopleCounterTable item={item}
                setSuccess={setUpdate}
                isSuperUser={isSuperUser}
                handleDeletePCount={handleDeletePCount}
              />
            </Grid>

            <Grid item xs={12} >
              <GatwayTable item={item} />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6}>
              <CameraTable item={item} />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <WifiTable item={item} />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} />
          </Grid>
        </Box>
      )}
    </Collapse>
  );
};

export default CollapseStationDetailComponent;
